import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";
import { useLocation } from "react-router-dom";

/**
 * Floating "back to top" button. Appears after the user scrolls > 400px.
 * Positioned bottom-right with generous offset to clear the "Made with Emergent"
 * badge that may sit at the corner on the deployed app.
 */
export default function BackToTopButton() {
    const [visible, setVisible] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 400);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollTop = () => {
        const reduce = window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
        window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
    };

    if (pathname.startsWith("/book") || pathname.startsWith("/checkout")) return null;
    return (
        <button
            type="button"
            onClick={scrollTop}
            aria-label="Back to top"
            data-testid="back-to-top"
            className={`fixed bottom-24 right-6 z-40 w-11 h-11 rounded-full border border-[#C29A5B]/60 bg-[#FBF6F0]/85 backdrop-blur text-[#8F622C] flex items-center justify-center shadow-lg shadow-[#6B1535]/20 transition-all duration-300 hover:bg-[#6B1535] hover:text-[#FFF8F2] hover:scale-110 ${visible ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none translate-y-2"}`}
        >
            <ArrowUp size={18} />
        </button>
    );
}
